var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var Draggable = require('../../libs/draggable');
var Element = require('../../dashboards/models/element');
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');
var edit = require('../../layout/components/edit');
var sortRecovery = require('./sortRecovery');

function getTableRecord(vnode) {
  if (!vnode || !vnode.attrs) return {};
  if (typeof vnode.attrs.tableRecord === 'function') {
    return vnode.attrs.tableRecord() || {};
  }
  return vnode.attrs.tableRecord || {};
}

function getColumnGroups(vnode) {
  var tableRecord = getTableRecord(vnode);
  return Array.isArray(tableRecord.columnGroups) ? tableRecord.columnGroups : [];
}

function setColumnGroups(vnode, columnGroups) {
  var tableRecord = getTableRecord(vnode);
  if (tableRecord && typeof tableRecord === 'object') {
    tableRecord.columnGroups = columnGroups;
  }
}

module.exports = {
  oninit: function oninit (vnode) {
    var ctrl = this;

    ctrl.name = prop('');
    ctrl.width = prop(1);
    ctrl.columnGroups = getColumnGroups(vnode);
    ctrl.options = vnode.attrs.options;
    ctrl.parentReinitialize = vnode.attrs.parentReinitialize;
    ctrl.sortError = null;
    ctrl.reloadAfterSortError = function () {
      return Promise.resolve()
        .then(function () {
          return typeof ctrl.parentReinitialize === 'function' ? ctrl.parentReinitialize() : null;
        })
        .then(function () {
          ctrl.sortError = null;
          m.redraw();
        })
        .catch(function (error) {
          console.error('Unable to reload table after a column-group order failure:', error);
          return null;
        });
    };

    ctrl.addColumn = function () {
      ctrl.name('');
      ctrl.width(1);
      modal.vm.title('Create Group');
      modal.vm.body = formView.bind(ctrl, ctrl);

      var submit = function () {
        ctrl.columnGroups.push({name: ctrl.name(), width: ctrl.width()});
        setColumnGroups(vnode, ctrl.columnGroups);
        return ctrl.putRecord()
        .then(function () {
          key.unbind('enter');
          modal.vm.close();
        })
      }

      modal.vm.buttons([
        {
          label: "Submit",
          class: "dib ",
          func: submit
        }
      ])

      key.setScope('modal');
      key('enter', 'modal', submit);

      modal.vm.open();
    };

    ctrl.editColumn = function (elementIndex, isColumnGroup) {
      if (!ctrl.columnGroups[elementIndex]) {
        return;
      }
      ctrl.name(ctrl.columnGroups[elementIndex]['name']);
      ctrl.width(ctrl.columnGroups[elementIndex]['width']);
      modal.vm.title('Edit Group');
      modal.vm.body = formView.bind(ctrl, ctrl);

      var submit =  function () {
        ctrl.columnGroups[elementIndex] = {name: ctrl.name(), width: ctrl.width()};
        setColumnGroups(vnode, ctrl.columnGroups);
        ctrl.putRecord()
        .then(function () {
          key.unbind('enter');
          modal.vm.close();
        })
      }

      modal.vm.buttons([
        {
          label: "Delete",
          class: "dib red mr3 ",
          func: ctrl.deleteColumn.bind(ctrl, elementIndex)
        },
        {
          label: "Submit",
          class: "dib ",
          func: submit
        }
      ])


      key.setScope('modal');
      key('enter', 'modal', submit);

      modal.vm.open();
    };

    ctrl.deleteColumn = function (elementIndex) {
      if (!ctrl.columnGroups[elementIndex]) {
        return;
      }
      modal.vm.title('Delete Group');
      modal.vm.body = prop(m('p', 'Are you sure?'));

      var submit =  function () {
        ctrl.columnGroups.splice(elementIndex, 1);
        setColumnGroups(vnode, ctrl.columnGroups);
        ctrl.putRecord()
        .then(function () {
          key.unbind('enter');
          modal.vm.close();
        })
      }

      modal.vm.buttons([
        {
          label: "Delete",
          class: "dib ",
          func: submit
        }
      ])


      key.setScope('modal');
      key('enter', 'modal', submit);

      modal.vm.open();
    };

    ctrl.sortChildren = (columnElements) => {
      var updatedColumns = columnElements.map(function (n) {
        return {width: Number(n.attributes.width.value), name: n.attributes.name.value};
      });

      setColumnGroups(vnode, updatedColumns);
      ctrl.columnGroups = updatedColumns;
      var tableRecord = getTableRecord(vnode);
      if (!tableRecord || !tableRecord['@rid']) {
        return Promise.resolve();
      }

      return sortRecovery.persistSortOrder({
        context: 'table column groups',
        message: 'Unable to reorder table column groups. The latest saved order was reloaded.',
        request: function () {
          return loaders.requestWithLoader({
            loader: 'background',
            method: 'PUT',
            url: '/api/v1/element/' + tableRecord['@rid'].slice(1),
            body: {
              columnGroups: updatedColumns
            }
          });
        },
        reload: ctrl.parentReinitialize,
        onSuccess: function () {
          ctrl.sortError = null;
        },
        onError: function (message) {
          ctrl.sortError = message;
          m.redraw();
        }
      });
    };

    ctrl.putRecord = function () {
      var tableRecord = getTableRecord(vnode);
      if (!tableRecord || !tableRecord['@rid']) {
        return Promise.resolve();
      }
      return loaders.requestWithLoader({
        loader: 'background',
        url: Element.getUrl(tableRecord),
        method: 'PUT',
        body: {columnGroups: ctrl.columnGroups}
      });
    };
  },
  onbeforeupdate: function onbeforeupdate(vnode) {
    this.columnGroups = getColumnGroups(vnode);
  },
  view: function view (vnode) {
    var ctrl = this
    var tableRecord = getTableRecord(vnode);
    var tableColumnGroups = getColumnGroups(vnode);
    var editableColumnGroups = Array.isArray(ctrl.columnGroups) ? ctrl.columnGroups : [];
    if (!edit.vm.editing()) {
      return m('tr', [
        m('td'),
        tableColumnGroups.map(function (col, idx) {
          return m('th.tc.v-btm.fw3.bw1.ph2', {class: col.width > 0 ? 'br bl' : '', colspan: col.width}, col.name)
        }),

      ]);
    }

    var draggableRow = m(Draggable, {onsort: ctrl.sortChildren, draggable: '.th-drag-colgroup', handleClass:'.th-drag-colgroup-handle', htmlElement: 'tr'}, [
      (ctrl.options && ctrl.options.preColumns) ? ctrl.options.preColumns : [],
      m('th'),
      editableColumnGroups.map(function (column, idx) {
        var columnName = typeof column == 'string' ? column : column.name;
        return m('th.tc.v-btm.bw1.ph2.th-drag-colgroup', {class: column.width > 0 ? 'br bl' : '', colspan: column.width, width: column.width, name: columnName, key: `${columnName}_${column.width}`}, [
          columnName === '' ?
            m('i.ion-edit.blue.th-drag-colgroup-handle', {onclick: ctrl.editColumn.bind(null, idx)}, columnName )
          :
            m('a.blue.th-drag-colgroup-handle', {onclick: ctrl.editColumn.bind(null, idx)}, columnName )
            
        ])
      }),
      m('th.bt-0.bl-0.br-0.bb-0.b--dotted.bw1', [
        m('i.icon.ion-plus.blue.dib.ml2', {onclick: ctrl.addColumn.bind(null, {out: tableRecord['@rid']})})
      ])
    ]);

    return ctrl.sortError ? m.fragment({}, [
      m('tr', [
        m('th.dark-red.tl', { colspan: editableColumnGroups.length + 1 }, [
          m('span', ctrl.sortError + ' '),
          m('button', { type: 'button', onclick: ctrl.reloadAfterSortError }, 'Refresh')
        ])
      ]),
      draggableRow
    ]) : draggableRow;
  }
};

function formView (ctrl) {
  return m("form", {role:"form"}, [
    m("div", {class:"form-group"}, [
      m("name", {for:"element-name-input"}, "Name"),
      m("input.form-control", {
        type:"text", 
        autocomplete: 'off',
        oninput: function(ev) {ctrl.name(ev.target.value)},
        value: ctrl.name(),
      }),
    ]),
    m("div", {class:"form-group"}, [
      m("width", {for:"element-width-input"}, "Width"),
      m("input.form-control", {
        type:"number", 
        autocomplete: 'off',
        oninput: function(ev) {ctrl.width(ev.target.value)},
        value: ctrl.width(),
      }),
    ])
  ]);
};

function arraymove(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
};
